import esES from "./es-ES.json";
import esMX from "./es-MX.json";
import enUS from "./en-US.json";
import caES from "./ca-ES.json";
import { Locales } from "@/shared/core/constants";


export const LOCALES = [
    { value: Locales.enUS, caption: 'English USA' },
    { value: Locales.esES, caption: 'Español' },
    { value: Locales.caES, caption: 'Català' }
];

const withSpainFallback = (overrides: { [key: string]: string }) => {
    const merged: { [key: string]: any } = { ...esES };
    Object.keys(overrides).filter(key => overrides[key] !== "").forEach(key => merged[key] = overrides[key]);
    return merged;
};

export const messages = {
    [Locales.esES]: esES,
    [Locales.esMX]: withSpainFallback(esMX),
    [Locales.enUS]: enUS,
    [Locales.caES]: caES
};

export const defaultLocale = Locales.enUS;

